import React from 'react';

import { get } from 'lodash';
import {
  MdFormatAlignCenter,
  MdFormatAlignJustify,
  MdFormatAlignLeft,
  MdFormatAlignRight,
  MdFormatBold,
  MdFormatClear,
  MdFormatIndentDecrease,
  MdFormatIndentIncrease,
  MdFormatItalic,
  MdFormatListBulleted,
  MdFormatListNumbered,
  MdFormatShapes,
  MdFormatStrikethrough,
  MdFormatUnderlined,
  MdLink,
  MdRedo,
  MdUndo,
} from 'react-icons/md';

const ICON_MAP = {
  'clear-formatting': <MdFormatClear />,
  bold: <MdFormatBold />,
  center: <MdFormatAlignCenter />,
  code: <MdFormatShapes />,
  indent: <MdFormatIndentIncrease />,
  italic: <MdFormatItalic />,
  justify: <MdFormatAlignJustify />,
  left: <MdFormatAlignLeft />,
  link: <MdLink />,
  ol: <MdFormatListNumbered />,
  outdent: <MdFormatIndentDecrease />,
  redo: <MdRedo />,
  right: <MdFormatAlignRight />,
  strikethrough: <MdFormatStrikethrough />,
  ul: <MdFormatListBulleted />,
  underline: <MdFormatUnderlined />,
  undo: <MdUndo />,
};

export const getIcon = (name: string) => get(ICON_MAP, name);
